import { rnd2 } from "../../Game";
import { WrappedArray } from "../../Utils/Collections/WrapperArray";
import { Grandstand } from "./Grandstand";



export interface GrandstandZoneSettings {
    /**
     * Pozice stredu zony
     */
    pos: pc.Vec3;
    /**
     * Rozmer zony
     */
    size: pc.Vec2;
}



export class GrandstandZoneMng {
    private _zones: GrandstandZoneSettings[];
    private _actZones: WrappedArray<GrandstandZoneSettings>;

    /**
     * (RO) Pocet aktivnich zon
     */
    get actZoneCnt(): number { return this._actZones.size; }

    private _tmpPos = new pc.Vec3();

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(zones: GrandstandZoneSettings[]) {
        this._zones = zones;
        this._actZones = new WrappedArray<GrandstandZoneSettings>(zones);
    }

    //-------------------------------------------------------------------------
    /**
     * Nastaveni aktivnich zone
     * @param actZoneMask 
     */
    //-------------------------------------------------------------------------
    setActZones(actZoneMask: number): void {
        this._actZones.clear(false);

        this._zones.forEach((zone: GrandstandZoneSettings, i: number): void => {
            if ((actZoneMask & (1 << i)) != 0)
                this._actZones.add(zone);
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getZonePos(hRatio: number, vRatio: number, zoneId: number): pc.Vec3 {
        let zone = this._actZones.getItemAtIndex(zoneId);

        this._tmpPos.x = (zone.pos.x - zone.size.x / 2) + zone.size.x * hRatio;
        this._tmpPos.y = (zone.pos.y - (zone.size.y / 2) * Grandstand.TILT_STEP_Y) + (zone.size.y * vRatio) * Grandstand.TILT_STEP_Y;
        this._tmpPos.z = (zone.pos.z - (zone.size.y / 2) * Grandstand.TILT_STEP_Z) + (zone.size.y * vRatio) * Grandstand.TILT_STEP_Z;

        return this._tmpPos;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getZoneRndPos(marginX: number, marginY: number, zoneId?: number): pc.Vec3 {
        if (zoneId == undefined)
            // Nahodne vybrat jednu z aktivnich zon
            zoneId = rnd2.randomIntIn(0, this._actZones.size - 1);

        let zone = this._actZones.getItemAtIndex(zoneId);
        let offsetY1 = zone.size.y / 2 - marginY;
        let offsetY2 = rnd2.randomIn(0, zone.size.y - marginY * 2);

        this._tmpPos.x = (zone.pos.x - zone.size.x / 2 + marginX) + rnd2.randomIn(0, zone.size.x - marginX * 2);
        this._tmpPos.y = (zone.pos.y - offsetY1 * Grandstand.TILT_STEP_Y) + offsetY2 * Grandstand.TILT_STEP_Y;
        this._tmpPos.z = (zone.pos.z - offsetY1 * Grandstand.TILT_STEP_Z) + offsetY2 * Grandstand.TILT_STEP_Z;

        //this._tmpPos.add(Grandstand.SHIFT_OFFSET);

        return this._tmpPos;
    }
}